import Button from '../components/ui/Button'
import PageIntro from '../components/ui/PageIntro'

function NotFound() {
  return (
    <PageIntro
      eyebrow="404"
      title="That page has left the lot"
      lede="The link is broken or the car has been delivered. Everything currently available is on the floor."
    >
      <div className="flex flex-wrap gap-3">
        <Button to="/home#cars" size="lg" arrow magnetic>
          Explore cars
        </Button>
        <Button variant="ghost" size="lg" to="/home">
          Back home
        </Button>
      </div>
    </PageIntro>
  )
}

export default NotFound
